import { EventBus } from "@/shared/eventBus";
import { CONTROLLER_STATES } from "../shared/constants/controllerStates";
import { NetworkManager } from "./NetworkManager";

declare global {
  interface Window {
    receiveNativeMessage: (message: string) => void;
  }
}

class Controller {
  private controllerState: number;
  private controlerId: string;
  private roomId: string;
  private networkManager: NetworkManager;

  private eventBus: EventBus<any>

  constructor(eventBus: EventBus<any>) {
    const controllerId = Android.getClientId();
    const roomId = Android.getRoomId();
    if (!controllerId || !roomId) {
      throw new Error("Controller initialization failed: missing controllerId or roomId");
    }
    this.controlerId = controllerId;
    this.roomId = roomId;
    this.eventBus = eventBus;
    if (!roomId || !controllerId) {
      throw new Error("invalid parameter to the Controller");
    }
    this.eventBus = eventBus;
    this.controllerState = CONTROLLER_STATES.BLOCKED;
    this.controlerId = controllerId;
    this.roomId = roomId;
    this.networkManager = new NetworkManager(controllerId, roomId);
    console.log("Controller initialized with ID:", this.controlerId, "and Room ID:", this.roomId);
    if (!this.networkManager) {
      throw new Error("Network manager initialization failed");
    }

    this.setupNetworkEventListeners();
    // Android.subscribeToOrientation();

    if ('receiveNativeMessage' in window) {
      console.log("receiveNativeMessage already defined");
    } else {
      console.log("Defining receiveNativeMessage");
    }
    window.receiveNativeMessage = (message: string) => {

      const [type, value] = message.split(":");

      if (type == "orientation.pitch") {
        const pitch = parseFloat(value);
        if (!isNaN(pitch)) {
          this.networkManager.sendApplicationMessage({
            orientationData: {
              pitch: pitch
            }
          })
        }
      }
    }
  }

  private setupNetworkEventListeners() {
    if (!this.networkManager) return;

    this.networkManager.on("websocket:connected", () => {
      this.eventBus.publish("connected", null);
    });

    this.networkManager.on("controller_type_assigned", (isPrimary) => {
      if (isPrimary) {
        this.eventBus.publish("role_recieved", "primary")
      } else {
        this.eventBus.publish("role_recieved", "secondary")
      }
    })

    this.networkManager.on("game_started", (url: string) => {
      //! update the console state here
      this.eventBus.publish("game_loaded", { url });
    })
  }

  async boot(): Promise<void> {
    this.setControllerState(CONTROLLER_STATES.BOOT);
    this.eventBus.publish("ui:show-loader", () => { });
    this.setupUIEventListeners();
    this.eventBus.publish("ui:show-connecting", () => { });

    await this.networkManager.connect();
  }

  setControllerState(state: number): void {
    this.controllerState = state;
  }

  private setupUIEventListeners() {
    this.eventBus.subscribe("room_ready", () => {
      this.networkManager.sendRoomReadyMessage();
    })

    this.eventBus.subscribe("menu:button_press", (data) => {
      this.networkManager.sendApplicationMessage({ menuAction: { button: data.button } })
    })

    this.eventBus.subscribe("game:accelerate_on", () => {
      this.networkManager.sendApplicationMessage({ gameAction: { action: "accelerate_on" } })
    })

    this.eventBus.subscribe("game:accelerate_off", () => {
      this.networkManager.sendApplicationMessage({ gameAction: { action: "accelerate_off" } })
    })

    this.eventBus.subscribe("game:brake_on", () => {
      this.networkManager.sendApplicationMessage({ gameAction: { action: "brake_on" } })
    })

    this.eventBus.subscribe("game:brake_off", () => {
      this.networkManager.sendApplicationMessage({ gameAction: { action: "brake_off" } })
    })
  }


  getControllerState(): number {
    return this.controllerState;
  }

  getClientId(): string | null {
    return this.controlerId;
  }

  getRoomId(): string | null {
    return this.roomId;
  }

  isConnected(): boolean {
    return this.networkManager?.isConnected() || false;
  }

  isDataChannelOpen(): boolean {
    return this.networkManager?.isDataChannelOpen() || false;
  }
}

export default Controller;
